import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import _ from 'lodash';
import moment from 'moment';

import { setRequestCreditDetails } from '../../../../redux/actions';

class RequestCreditStep3 extends Component {

	constructor(props) {
		super(props);
		this.state = {
			errorMessage: '',
			creditType: '',
		}
	}

	componentWillMount() {
		// Redirect to request return page if there is no data in store, it means page is refreshed
		const self = this;
		const { requestCreditDetails, requestCreditFilterListOfOrders } = self.props.order;
		if(!requestCreditDetails) {
			browserHistory.push("/requestcredit");
		} else {
			const creditType = requestCreditFilterListOfOrders && requestCreditFilterListOfOrders.param ? requestCreditFilterListOfOrders.param.creditType: '';
			self.setState({
				creditType,
			});
		}
	}

	componentDidMount() {
		window.scrollTo(0, 0);
	}

	handlePercentage(indexx, event){
		var value = event.target.value
		const self = this;
		let { requestCreditDetails } = self.props.order;
		const { CUSTOMERCLASSCODE} = self.props.user.accountDetail.responseObject !== null && self.props.user.accountDetail.responseObject !== 'undefined' ? self.props.user.accountDetail.responseObject[0]: '';
		requestCreditDetails.responseObject.items.forEach((item, index) => {
			const isAsIsn180 = moment(item.invoiceDate).isBefore(moment().subtract(180, 'days'), 'day') && CUSTOMERCLASSCODE === "AS-IS" ? true : false;
			if(index === indexx) {
				item.percentage = isAsIsn180 && value > 50 ? 50 : value > 100 ? 100 : value;
				item.percentageError = '';
				delete item.amount;
				delete item.amountError;
			}
		});
		self.setState({errorMessage: ''});
		self.props.setRequestCreditDetails(requestCreditDetails);
	}

	handleAmount(indexx, event){
		var value = event.target.value
		const self = this;
		let { requestCreditDetails } = self.props.order;
		requestCreditDetails.responseObject.items.forEach((item, index) => {
			if(index === indexx) {
				item.amount = (value*1) > (item.price*1) ? item.price : value; // string are converted to numbers  by multiplying by 1
				item.amountError = '';
				delete item.percentage;
				delete item.percentageError;
			}
		});
		self.setState({errorMessage: ''});
		self.props.setRequestCreditDetails(requestCreditDetails);
	}

handleContinue() {
		const self = this;
		const { creditType } = self.state;
		const { requestCreditDetails } = self.props.order;
		let formError = false;
		requestCreditDetails.responseObject.items.forEach((item, index) => {
			if(item.selected){
				if((!item.percentage || item.percentage === '0') && (!item.amount || item.amount === '0')) {
					this.setState({
						errorMessage: 'Please enter either amount or percentage',
					});
					item.amountError = 'error';
					item.percentageError = 'error';
					formError = true;
				} else if(creditType === 'Damage Allowances' && item.percentage && parseInt(item.percentage, 10) > 40) {
					this.setState({
						errorMessage: 'Damage Allowances are limited to 40%',
					});
					item.percentageError = 'error';
					formError = true;
				} else if(creditType === 'Damage Allowances' && item.amount) {
					let perItemPrice = parseFloat(item.price);
					perItemPrice = parseFloat(perItemPrice * 0.4).toFixed(2); // 40% of unit price
					if(parseFloat(item.amount) > parseFloat(perItemPrice)) {
						this.setState({
							errorMessage: 'Damage Allowances are limited to 40%',
						});
						item.amountError = 'error';
						formError = true;
					} 
				// }  else if(creditType === 'Push/Pull Credit' && item.percentage && parseInt(item.percentage, 10) > 40) {
				// 	this.setState({
				// 		errorMessage: 'Push/Pull Credit are limited to 40%',
				// 	});
				// 	item.percentageError = 'error';
				// 	formError = true;
				 } else if(creditType === 'Push/Pull Credit' && item.amount > 125) {
					//let perItemPrice = parseFloat(item.price);
					//perItemPrice = parseFloat(perItemPrice * 0.4).toFixed(2); // 40% of unit price
					//if(parseFloat(item.amount) > parseFloat(perItemPrice)) {
						this.setState({
							errorMessage: 'Push/pull credits are limited to $125',
						});
						item.amountError = 'error';
						formError = true;
					//} 
				}else if(creditType === 'Delivery/Services/Fees' && item.percentage && parseInt(item.percentage, 10) > 100) {
					this.setState({
						errorMessage: 'Delivery/Services/Fees are limited to 100%',
					});
					item.percentageError = 'error';
					formError = true;
				} else if(creditType === 'Delivery/Services/Fees' && item.amount && parseFloat(item.amount) > parseFloat(item.price)) {
					item.amountError = '';
					item.amount = item.price;
				}
			}
		})
		self.props.setRequestCreditDetails(requestCreditDetails);
		if(!formError){
			this.setState({
				errorMessage: '',
			})
			// Update price according to percentage or actual and then redirect
			let orderTotal = 0.00;
			requestCreditDetails.responseObject.items.forEach(item => {
				if(item.selected) {
					let price = 0;
					if(item.percentage) {
						price = parseFloat(item.price) * item.percentage / 100;
					} else {
						price = parseFloat(item.amount);
					}
					item.updatedPrice = parseFloat(price).toFixed(2);
					orderTotal += (item.updatedPrice) * parseFloat(item.returnQuantity);
					item.creditAmount = (item.updatedPrice) * parseFloat(item.returnQuantity);
				}
			});

			requestCreditDetails.responseObject = {
				...requestCreditDetails.responseObject,
				orderTotal: parseFloat(orderTotal).toFixed(2),
			}
			browserHistory.push("/requestcreditstep4");
		}
	}	
	handleGoToStep(step, event) {
		event.preventDefault();
		browserHistory.push(step);
	}

	render() {
		const self = this;
		const orderDetails = this.props.order.requestCreditDetails && this.props.order.requestCreditDetails.responseObject;
        return (
			<div className='container'>
				<div className="d-none d-sm-block">
					<div>
						<h1 className="pageTitle">Request Credit</h1>
						{this.state.creditType?<p className="pad-b-1em">
							Please enter the dollar amount you are requesting for credit.
						</p>:<p className="pad-b-1em">
							Please enter the percentage of price <strong>OR</strong> dollar amount you are requesting for credit.
						</p>}
						<p className="bold red">{this.state.errorMessage}</p>
					</div>
					{orderDetails &&
						<div className="push">
							<div className="captionAboveTable captionAboveManageOrdersTable">
								<div className="columns twoColumns">
									<div className="column">
										<div className="bold big">
											CSO (Order number): {orderDetails.orderNumber}
										</div>
									</div>
									<div className="column textCenter">
										<div className="bold big">
											Order Date: {this.props.formatDate(orderDetails.orderDate, 'MM/DD/YY')}
										</div>
									</div>
									<div className="column textRight">
										<div className="bold big">
											P.O. # {orderDetails.poNumber}
										</div>
									</div>
								</div>
							</div>
							<table className="dataTable returnProductsOrderListTable withAlternatingTbodyElements" width="100%">
								<thead>
									<tr>
										<th className="poNumber">Product</th>
										<th className="invoiceDate">Credit<br />Quantity</th>
										<th className="invoiceDate">Invoice #</th>
										<th className="enteredBy">Credit Reason</th>
										<th className="poNumber">Price<br/>(Each)</th>
										{this.state.creditType == 'Push/Pull Credit'?"":<th>Credit %<br/>of Price</th>}
										<th className="invoiceDate">Credit<br/>Amount (Each)</th>
									</tr>
								</thead>
								{orderDetails.items.map((item, index) => {
									if(!item.selected) return null;
									return <tbody key={index}>
										<tr>
											<td className="poNumber">{item.item}</td>
											<td className="bold">{item.returnQuantity}</td>
											<td className="invoiceDate bold">{item.invoiceNumber}</td>
											<td className="enteredBy">{item.reasonCategoryLabel}</td>
											<td className="poNumber">{self.props.formatAmount2Decimal(item.price)}</td>
											{this.state.creditType == 'Push/Pull Credit'?"":<td>
												<table>
													<tbody>
														<tr>
														<td>
															<input type="text" className={item.percentageError} size={5} onKeyPress={this.props.acceptNumbersOnly} onChange={this.handlePercentage.bind(this, index)} value={item.percentage || ''}  />
														</td>
														<td>%</td>
														</tr>
													</tbody>
												</table>
											</td>}
											<td className="invoiceDate">
												<table>
													<tbody>
														<tr>
															<td>$</td>
															<td>
																<input type="text" className={item.amountError} size={8} onKeyPress={this.props.acceptNumbersOnly} onChange={this.handleAmount.bind(this, index)} value={item.amount || ''}  />
															</td>
														</tr>
													</tbody>
												</table>
											</td>
										</tr>
									</tbody>
								})}
							</table>
							<div className="columns">
								<div className="column">
									<input onClick={(e) => this.handleGoToStep('/requestcredit', e)} type="button" defaultValue="Cancel" className="blueButton" />
								</div>
								<div className="column textRight">
									<input type="submit" onClick={this.handleContinue.bind(this)} value="Continue" />
								</div>
							</div>
							<p>
								<a href="" onClick={(e) => this.handleGoToStep('/requestcreditstep2', e)} className="bold">Return to previous screen</a>
							</p>
						</div>
					}
				</div>

				{/*Mobile view*/}
				<div className="d-block d-sm-none container">
					<div>
						<h1 className="pageTitle">Request Credit</h1>
						{this.state.creditType?<p className="pad-b-1em">
							Please enter the dollar amount you are requesting for credit.
						</p>:<p className="pad-b-1em">
							Please enter the percentage of price <strong>OR</strong> dollar amount you are requesting for credit.
						</p>}
						<p className="bold red">{this.state.errorMessage}</p>
					</div>

					{orderDetails && 
						<div className='container headerColor captionContainer'>
						<div className='row'>
							<div className='col-5 d-flex align-items-center'>
								<div>CSO (Order number): {orderDetails && orderDetails.orderNumber}</div>
								<div className="vr vrLinePosition vrLineWidth"></div>
							</div>
							<div className='col-4 d-flex align-items-center'>
								<div>
								Order Date: {this.props.formatDate(orderDetails.orderDate, 'MM/DD/YY')}
								</div>
								<div className="vr vrLineWidth"></div>
							</div>
							<div className='col-3 d-flex align-items-center'>
								<div>
								P.O. # {orderDetails && orderDetails.poNumber}
								</div>
							</div>
						</div>
					</div>
					}
					{orderDetails && orderDetails.items.map((item, index) => {
								if(!item.selected) return null;

					return <div className="accordion removeAccBorder accordion-borderless" id={`accordionRequestReturnCreditStep3${index}`}  key={index}>
									<div className="accordion-item">

										<h2 className="accordion-header" id={`headingRequestReturnCreditStep3${index}`}>
											<div className=''>
												<div className='row accBtn'>
													
													<div className='col-12'>
														<button className="accBtn accordion-button font-size-14 collapsed " type="button" data-bs-toggle="collapse" data-bs-target={`#collapseRequestReturnCreditStep3${index}`} aria-expanded="true" aria-controls={`collapseRequestReturnCreditStep3${index}`}>
															<span className='spaceBetweenText'>PRODUCT</span>  {item.item}
														</button>
													</div>
												</div>
											</div>
										</h2>	

										<div id={`collapseRequestReturnCreditStep3${index}`}
															className={`accordion-collapse collapse accBody show`} 
															aria-labelledby={`headingRequestReturnCreditStep3${index}`}
															show>

											<div className="">
												
											<div className="row ">
													<div className="col-8 fw-bold pt-4">Credit Quantity</div>
													<div className="col-4 text-end pt-4">
														{item.returnQuantity}
													</div>
													<hr className="hr hrSpec" />
											</div>
											
												<div className="row ">
													<div className="col-8 fw-bold">Invoice #</div>
													<div className="col-4 text-end">{item.invoiceNumber}</div>
													<hr className="hr hrSpec" />
												</div>

												<div className="row ">
													<div className="col-6 fw-bold">Credit Reason</div>
													<div className="col-6 text-end">{item.reasonCategoryLabel}</div>
													<hr className="hr hrSpec" />
												</div>

												<div className="row ">
													<div className="col-8 fw-bold">Price (Each)</div>
													<div className="col-4 text-end">{self.props.formatAmount2Decimal(item.price)}</div>
													<hr className="hr hrSpec" />
												</div>

												

												<div className="row ">
													<div className="col-6 fw-bold">Credit % of Price</div>
													<div className="col-6 text-end d-flex justify-content-between">
													<input type="text" className={`fullWidth form-control inputHeight ${item.percentageError}`} size={5} onKeyPress={this.props.acceptNumbersOnly} onChange={this.handlePercentage.bind(this, index)} value={item.percentage || ''}  />
													<span className='d-flex justify-content-center align-items-center'>%</span>
													</div>
													<hr className="hr hrSpec" />
												</div>

												<div className="row mb-3">
													<div className="col-6 fw-bold">Credit Amount (Each)</div>
													<div className="col-6 text-end d-flex justify-content-between">
														<span className='d-flex justify-content-center align-items-center'>$</span>
														<input type="text" className={`fullWidth form-control inputHeight ${item.amountError}`} size={8} onKeyPress={this.props.acceptNumbersOnly} onChange={this.handleAmount.bind(this, index)} value={item.amount || ''}  />
													</div>
													
												</div>
											</div>
										</div>
									</div>
								</div>
							})}

					<div className="d-flex justify-content-between mt-3 ps-1 pe-1">
							<span>
								<button id="cancelButton" className='btnSize cancelButtonSpec' onClick={(e) => this.handleGoToStep('/requestcredit', e)}>Cancel</button>
							</span>
							
							<span>
								<button id="continueButton" className='btnSize' onClick={this.handleContinue.bind(this)}>Continue</button>
							</span>
						</div>
					

					<div className="container mt-4 backLink">
						<a href="" onClick={(e) => this.handleGoToStep('/requestcreditstep2', e)} className="bold">Return to previous screen</a>
						</div>
					
					<div style={{height:"200px"}}></div>

				</div>

			  </div>
        );
    }
}

const mapStateToProps = (state) => {
	return {
		order: state.order,
		user: state.user
	};
};

const mapDispatchToProps = (dispatch) => ({
	setRequestCreditDetails: (data) => dispatch(setRequestCreditDetails(data))
});

RequestCreditStep3 = connect(mapStateToProps, mapDispatchToProps)(RequestCreditStep3);
export default RequestCreditStep3;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Order/RequestCredit/requestCreditStep3.js